<div [class]="bgColorSig()">
  <div class="bg-neon pt-[7rem] pb-6 rounded-t-3xl">
    <div class="page-content-padding page-content-max-width">
      <div class="flex flex-col md:flex-row justify-between gap-8">
        <div class="grow">
          <img
            src="/images/klubovna-logo-night.svg"
            alt="klubovna-logo"
            class="max-w-[75%] h-auto will-change-transform" />
        </div>

        <div class="grow flex flex-col md:flex-row justify-end text-sm gap-10 max-md:mt-12">
          <div>
            <h2 class="font-semibold text-transform: uppercase">{{ 'index' | translate }}</h2>
            <ul class="mt-2 space-y-1">
              @for (menuItem of menuItems(); track menuItem.id) {
                <li
                  class="hover:underline"
                  (click)="navigateOrScroll(menuItem, 'footer-' + menuItem.routerLink)">
                  <p class="cursor-pointer">
                    {{ menuItem.key | translate }}
                  </p>
                </li>
              }
            </ul>
          </div>
          <div>
            <h2 class="font-semibold text-transform: uppercase">{{ 'contact' | translate }}</h2>
            <address class="mt-2 not-italic">
              {{ contactInfo.organization }}
              <br />
              {{ contactInfo.address.street }}
              <br />
              {{ contactInfo.address.city }}, {{ contactInfo.address.postalCode }}
              <br />
              {{ contactInfo.address.country }}
              <br />
              {{ 'ico' | translate }}: {{ contactInfo.ico }}
              <br />
              <a
                [href]="'mailto:' + contactInfo.email"
                (click)="clickEvent('footer-mailto')"
                class="hover:underline">
                {{ contactInfo.email }}
              </a>
              <br />
            </address>
            <a
              [href]="'tel:' + contactInfo.phone"
              (click)="clickEvent('footer-tel')"
              class="hover:underline">
              {{ contactInfo.phone }}
            </a>
          </div>

          <div>
            <h2 class="font-semibold text-transform: uppercase">{{ 'follow_us' | translate }}</h2>
            <ul>
              @for (socialItem of socialItems; track socialItem.platform) {
                <li>
                  <a
                    [href]="socialItem.link"
                    (click)="clickEvent('footer-' + socialItem.platform)"
                    class="mt-2 block hover:underline"
                    target="_blank"
                    rel="noopener noreferrer">
                    <span class="flex items-center">
                      <span class="mr-1">
                        <img
                          class="w-5 h-5"
                          [src]="socialItem.icon"
                          alt="" />
                      </span>
                      {{ socialItem.handle }}
                    </span>
                  </a>
                </li>
              }
            </ul>
          </div>
        </div>
      </div>

      <div class="w-full mt-12 text-xs flex justify-between">
        <p>
          <span class="material-symbols-outlined text-xs">copyright</span>
          (k)lubovňa {{ currentDate() | date: 'y' }} • v{{ version }} •
          {{ 'all_rights_reserved' | translate }}
          @if (!documentsLoadingSig() && documentsSig().length > 0) {
            @for (doc of documentsSig(); track doc.id) {
              •
              <a
                [href]="getDocumentPath(doc)"
                (click)="clickEvent('footer-' + doc.identifier)"
                target="_blank"
                class="!underline">
                {{ getDocumentName(doc) }}
              </a>
            }
          }
        </p>
        <a
          class="hover:underline cursor-pointer whitespace-nowrap pl-4 flex items-center gap-2"
          (click)="scrollToTop()">
          {{ 'return_to_top' | translate }}
          <span class="material-symbols-outlined text-xs">north</span>
        </a>
      </div>
    </div>
  </div>
</div>
